;
(function($){
    function initRating($el) {
        var $input = $('input', $el);
        var $stars = $('i', $el);
        var $help = $el.parentsUntil('row').find('.ratingHelp')
        var currentVal = parseInt($input.val()) || 0;
        var stateOn = $el.data('stateOn');
        var stateOff = $el.data('stateOff');

        var showRating = function(rating) {
            $stars.each(function(i, star){
                var $star = $(star);
                $star.removeClass(stateOn);
                $star.removeClass(stateOff);
                if ( i < rating ) {
                    $star.addClass(stateOn);
                } else {
                    $star.addClass(stateOff);
                }
            });
        };

        var showHelp = function(rating) {
            switch (rating) {
                case 1:
                    $help.text("I'm not a fan"); break;
                case 2:
                    $help.text("It could be better"); break;
                case 3:
                    $help.text("It was okay, except for a few things…"); break;
                case 4:
                    $help.text("It was really good!"); break;
                case 5:
                    $help.text("Woohoo! I loved it!"); break;
                default:
                    $help.text(""); break;
            }
        };

        var setRating = function(rating) {
            $input.val(rating);
            currentVal = rating;
            showRating(rating);
            showHelp(rating);
        };

        $stars.each(function(i, star) {
            var idx = i+1;
            var $star = $(star);
            $star.on('click', function(e){
                e.preventDefault();
                var $thisStar = $(this);
                $thisStar.addClass("pulse");
                setTimeout(function() { $thisStar.removeClass("pulse"); }, 250);
                setRating(idx);
            });

            $star.on('mouseenter', function(e){
                showRating(idx);
                showHelp(idx);
            });
        });

        $el.on('mouseleave', function(e) {
            showRating(currentVal);
            showHelp(currentVal);
        });
    }

    $.fn.rating = function() {
        return this.each(function() {
            initRating($(this));
        });
    };
})( jQuery );